/**
 * An enum representing the destination where the Analytics are going to be reported.
 */
export enum AnalyticsDestinations {
  MIXPANEL = 'Mixpanel',
  ANALYTICS = 'Analytics',
  ATTENDEE_ACTIVITIES = 'AttendeeActivities'
}

/**
 * Represents the options parameter for anonymousId.
 * Ref: https://github.com/rudderlabs/rudder-sdk-js/blob/production-staging/packages/npm/index.d.ts
 */
export interface anonymousIdOptions {
  autoCapture?: {
    enabled?: boolean;
    source?: string;
  };
}

/**
 * Type for the exported APIs from `rudder-sdk-js` package.
 *
 * Re-written from https://github.com/rudderlabs/rudder-sdk-js/blob/production-staging/packages/npm/index.d.ts
 * because the package does not currently provide the type for its exported members.
 */
export type RudderAnalytics = {
  getAnonymousId: (options?: anonymousIdOptions) => string;
  ready(callback: () => void): void;
};
